import React from 'react';

import {ProteinAnnotationsPanelState} from 'FileStates';
import Protein from 'molbio/proteins/Protein';
import ProteinAnnotationsPanel from 'toolbar/protein/ProteinAnnotationsPanel';
import ReactPanelBaseView, {Subpanel} from 'toolbar/ReactPanelBaseView';

class ProteinAnnotationsPanelView extends ReactPanelBaseView<ProteinAnnotationsPanelState, Protein> {
  getSubpanels(): Array<Subpanel> {
    return [
      {
        key: 'proteinAnnotationsPanel',
        title: 'Annotations',
        component: <ProteinAnnotationsPanel proteinId={this.model.id} />,
      },
    ];
  }
}

export default ProteinAnnotationsPanelView;
